export const SHOW_SPINNER = '@SHOW_SPINNER';
export const HIDE_SPINNER = '@HIDE_SPINNER';
export const TOAST_SUCCESS = '@TOAST_SUCCESS';
export const TOAST_ERROR = '@TOAST_ERROR';
export const TOAST_WARNING = '@TOAST_WARNING';
export const SET_USER_INFO = '@SET_USER_INFO';
export const SET_UPDATE_LOGGED_INFO = '@SET_UPDATE_LOGGED_INFO';
